"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var screens = {
  diversity: 'diversity',
  additionalInformation: 'additional-information',
  workEligibility: 'work-eligibility'
};
var _default = screens;
exports.default = _default;